import React, { useState, useEffect, useRef } from 'react';
import './MemberProfile.css';

import { PageTitle, ParkingInfo } from '../../../components';
import { renderIcon } from '../../../utils';
import { memberFeatures } from '../../../constants';

import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { MemberProfileItem } from '../../../components';
import { MessageModal, InputMessageModal } from '../../../components';
import { useTokenCheck, getMemberProfile, callRemovePayment } from '../../../constants';
import Cookies from 'js-cookie';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const MemberProfile = () => {
  const { nickName, isCanExecute } = useTokenCheck();

  const location = useLocation();
  const serviceSingle = location.state;

  const navigate = useNavigate();

  let userProfileDataInit = [
    { label: '暱稱', value: '' },
    { label: '電話', value: '' },
    { label: '大潤發會員卡號', value: '' }
  ];
  const [userProfileData, setUserProfileData] = useState(userProfileDataInit);

  let platesDataInit = [
    { label: '----', value: '未設定' },
    // { label: '機車(1)', value: '未設定' },
  ];
  const [platesData, setPlatesData] = useState(platesDataInit);

  let paymentDataInit = [
    { label: '----', value: '未設定' },
  ];
  const [paymentData, setPaymentData] = useState(paymentDataInit);

  let invoiceDataInit = [
    { label: '----', value: '未設定' },
  ];
  const [invoiceData, setInvoiceData] = useState(invoiceDataInit);

  const handleEditClick = (path) => {
    navigate(path)
  };

  useEffect(() => {
    if (!isCanExecute) return;
    getMemberProfile().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;


      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果
          const userProfile = payload.data.userProfile;
          const plates = payload.data.plates;
          const payment = payload.data.payment;
          const invoice = payload.data.invoice;

          if (userProfile != null) {
            let userProfileData = [
              { label: '暱稱', value: userProfile.nickName },
              { label: '電話', value: userProfile.phone },
              { label: '大潤發會員卡號', value: userProfile.cardNo }
            ];
            setUserProfileData(userProfileData)
          }

          if (plates != null) {

            console.log(plates);

            let platesData = [];
            let temp1 = plates['1'];
            let temp2 = plates['2'];


            if (temp1 != null) {
              console.log(temp1)
              for (let index = 0; index < temp1.plates.length; index++) {
                let data = { label: temp1.type + "(" + (index + 1) + ")", value: temp1.plates[index] };
                platesData.push(data);
              }
            } else {
              // platesData.push(platesDataInit[0]);
            }
            if (temp2 != null) {
              console.log(temp2)
              for (let index = 0; index < temp2.plates.length; index++) {
                let data = { label: temp2.type + "(" + (index + 1) + ")", value: temp2.plates[index] };
                platesData.push(data);
              }
            } else {
              // platesData.push(platesDataInit[1]);
            }

            if (platesData.length === 0) {
              platesData.push(platesDataInit[0]);
            }

            setPlatesData(platesData)
          }

          if (payment != null) {

            let name = "";
            if (payment.type === "CREDITCARD") {
              name = "信用卡";
            }

            if (payment.type === "LINE") {
              name = "LINE PAY";
            }

            let paymentData = [
              { label: '支付方式', value: name },
            ];
            setPaymentData(paymentData)
          }

          if (invoice != null) {
            let invoiceData = [];
            let labelValue = '';
            if (invoice.type === 1) {
              labelValue = '行動載具';
              invoiceData[0] = { label: labelValue, value: invoice.deviceID };
            } else if (invoice.type === 2) {
              labelValue = '捐贈發票（愛心碼）';
              invoiceData[0] = { label: labelValue, value: invoice.deviceID };
            } else if (invoice.type === 3) {
              labelValue = 'Email';
              invoiceData[0] = { label: labelValue, value: invoice.deviceID };

              //"發票類型, 0: 二聯式 1:三聯式"
              if (invoice?.invoiceType === 0) {
                invoiceData[1] = { label: "發票類型", value: "二聯式" };
              }
              if (invoice?.invoiceType === 1) {
                invoiceData[1] = { label: "發票類型", value: "三聯式" };

                invoiceData[2] = { label: "公司名稱", value: invoice.companyName };
                invoiceData[3] = { label: "統一編號", value: invoice.companyID };
              }
            }

            setInvoiceData(invoiceData);
          }

        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

    if (Cookies.get('cookieConsent') === 'accepted') {

      if (Cookies.get('isRegistreProcessing') === 'true') {
        Cookies.remove('isRegistreProcessing');
      }

    } else {

      // 沒有同意 Cookie 的情況
    }
  }, [isCanExecute]);

  useEffect(() => {
    const InputMessageModalComponent = () => {
      const callApiRemovePayment = (inputValue, closeModal) => {
        console.log('輸入框的值:', inputValue);
        let password = inputValue;

        const validateLength = (value) => {
          return value.trim().length === 0;
        };

        if (validateLength(password)) {
          MessageModal.alert('請輸入密碼進行驗證');
          return
        }

        callRemovePayment(password).then(payload => {
          const isPayloadValid =
            payload?.status !== undefined &&
            payload?.errorCode !== undefined &&
            payload?.errorMessage !== undefined;

          if (isPayloadValid) {
            if (payload.status === 0 && payload.errorCode === '0000') {

              closeModal();
              MessageModal.alert(payload.errorMessage, () => handleEditClick('/payment?action=update'));

            } else if (payload.status === 1 &&
              (payload.errorCode === '9997' || payload.errorCode === '9998')) {
              //未登入
              let errorMessage = "Token過期，或發生異常，需要重新登入！";
              MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
            } else if (payload.status === 1 && payload.errorCode === '9996') {
              //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
              let errorMessage = "查無此會員，或發生異常，需要重新登入！";
              MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
            } else {
              let errorMessage = payload.errorMessage;
              MessageModal.alert(errorMessage);
            }
          }
        }).catch(error => {
          console.error('Error during API call:', error);
        });
      };
      InputMessageModal.show(
        '要變更支付方式，需要先輸入密碼解除支付綁定（一但解除就無法復原）：',
        callApiRemovePayment
      );
    };
    if (paymentData[0].value !== '未設定') {
      setHandlePaymentClick(() => InputMessageModalComponent);
    } else {
      setHandlePaymentClick(() => () => handleEditClick('/Payment?action=update'));
    }
  }, [paymentData]);

  const [handlePaymentClick, setHandlePaymentClick] = useState(() => () => handleEditClick('/Payment?action=update'));







  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'會員中心'} page={'member center'} />

      <section className='service-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            {/* <SidebarHeading title={''} /> */}

            <div className='box-container'>
              {memberFeatures.map(memberFeatures => {
                return (
                  /* Link to the individual service page */
                  <Link
                    to={{
                      pathname: memberFeatures.link,
                    }}
                    location={{ memberFeatures }}
                    state={memberFeatures}
                    key={memberFeatures.id}
                    className='item'><span><div className='icon'>{renderIcon(memberFeatures.title)}</div>{memberFeatures.title}</span> {/* Service Title */}
                  </Link>)
              })}
            </div>

          </div>

        </div>

        <div className='service-info'>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>會員基本資料</h3>
            <div className='member-profile-area'>
              <div className='info-box'>
                {/* <div className="parking-date">個人資料</div> */}
                <div className="title">個人資訊</div>
                <div className="plateNo">
                  <button name="changeProfile" id="changeProfile" className='btn'
                    onClick={() => handleEditClick('/Register?action=update')}>修改</button>
                </div>
                <div className="split"> </div>
                <MemberProfileItem members={userProfileData} />
                {/* <div className="split"> </div> */}
                <div className="parking-remain-label"></div>
                <div className="parking-remain"></div>
              </div>
            </div>
            <div className='member-profile-area'>
              <div className='info-box'>
                {/* <div className="parking-date">個人資料</div> */}
                <div className="title">愛車設定</div>
                <div className="plateNo">
                  <button name="changeProfile" id="changeProfile" className='btn'
                    onClick={() => handleEditClick('/PlateSetting?action=update')}>修改</button>
                </div>
                <div className="split"> </div>
                <MemberProfileItem members={platesData} />
                {/* <div className="split"> </div> */}
                <div className="parking-remain-label"></div>
                <div className="parking-remain"></div>
              </div>
            </div>
            <div className='member-profile-area'>
              <div className='info-box'>
                {/* <div className="parking-date">個人資料</div> */}
                <div className="title">繳費與付款</div>
                <div className="plateNo">
                  <button name="changeProfile" id="changeProfile" className='btn'
                    onClick={handlePaymentClick}>修改</button>
                </div>
                <div className="split"> </div>
                <MemberProfileItem members={paymentData} />
                {/* <div className="split"> </div> */}
                <div className="parking-remain-label"></div>
                <div className="parking-remain"></div>
              </div>
            </div>
            <div className='member-profile-area'>
              <div className='info-box'>
                {/* <div className="parking-date">個人資料</div> */}
                <div className="title">發票</div>
                <div className="plateNo">
                  <button name="changeProfile" id="changeProfile" className='btn'
                    onClick={() => handleEditClick('/Invoice?action=update')}>修改</button>
                </div>
                <div className="split"> </div>
                <MemberProfileItem
                  members={invoiceData}
                  customStyles={{
                    label: { textTransform: 'none' },
                    value: { textTransform: 'none' }
                  }} />
                {/* <div className="split"> </div> */}
                <div className="parking-remain-label"></div>
                <div className="parking-remain"></div>
              </div>
            </div>
          </div>

        </div>

      </section>
    </>
  );
}

export default MemberProfile;
